/*
  Ein kleiner Baustein fuer den Kopfbereich des Wissensbereichs.

  Enthaelt nur noch wissen-band-slider: die Pfeile am Kategorie-Band und
  das Schieben zur aktiven Pill beim Laden.

  Lupe und Hamburger brauchen kein eigenes Skript mehr: Sie oeffnen seit dem
  20.08.2026 die Schubladen des Themes, und die bindet das Theme selbst ueber
  aria-controls.

  Die Pfeile sind Zugabe, keine Voraussetzung. Laedt diese Datei nicht,
  laesst sich das Band weiter wischen, die Pfeile erscheinen dann nicht.
*/

/*
  Pfeile zum Schieben des Kategorie-Bands.

  Vorbild ist die Kategorie-Seite von mybacs: Pfeile auf Desktop, mobil wird
  gewischt. Deshalb blenden sich die Pfeile aus, sobald das Geraet Wischen
  kann oder nichts zu schieben ist.

  Bewusst ohne Bibliothek und ohne Abhaengigkeit vom uebrigen Theme-JS. Das
  Band muss auch dann noch bedienbar sein, wenn dieses Skript nicht laedt:
  Der Bereich bleibt in jedem Fall mit dem Finger und mit der Tastatur
  schiebbar, die Pfeile sind eine Zugabe, keine Voraussetzung.
*/

if (!customElements.get('wissen-band-slider')) {
  customElements.define(
    'wissen-band-slider',
    class WissenBandSlider extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.wissen-band__slider');
        this.arrows = this.querySelector('.wissen-band__arrows');
        if (!this.scroller || !this.arrows) return;

        this.buttons = Array.from(this.querySelectorAll('.wissen-band__arrow'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.slide(Number(button.dataset.dir)));
        });

        this.update = this.update.bind(this);
        this.scroller.addEventListener('scroll', this.update, { passive: true });

        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.scroller);

        this.update();
        this.zeigeAktive();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.scroller?.removeEventListener('scroll', this.update);
      }

      /*
        Beim Laden zur aktiven Pill schieben.

        Grund: Das Band traegt 17 Eintraege. Auf einer gefilterten Adresse
        wie /blogs/wissen/tagged/schlaf steht die gefuellte Pill oft
        ausserhalb des Sichtfelds. Das Band ist laut Regel 3 gleichzeitig
        Ortsanzeige, und eine Ortsanzeige, die man erst suchen muss,
        zeigt nichts an.

        Drei Dinge, die hier absichtlich so sind:

        1. Nur waagerecht. scrollIntoView wuerde je nach Browser auch die
           Seite senkrecht verschieben, der Beitrag saesse dann beim Laden
           schon angescrollt da. Deshalb wird scrollLeft direkt gesetzt.
        2. Ohne Animation. Beim Laden soll das Band bereits richtig
           stehen, ein sichtbares Nachrutschen sieht nach Fehler aus.
        3. Nur wenn noetig. Ist die aktive Pill ohnehin ganz zu sehen,
           passiert nichts. Auf der ungefilterten Startseite bleibt das
           Band also am Anfang stehen.

        Gemessen wird ueber getBoundingClientRect, nicht ueber offsetLeft:
        offsetLeft bezieht sich auf den naechsten positionierten Vorfahren,
        und der ist hier nicht der Slider, sondern eine Ebene darueber.
      */
      zeigeAktive() {
        const aktiv = this.scroller.querySelector('.is-active');
        if (!aktiv) return;

        const rest = this.scroller.scrollWidth - this.scroller.clientWidth;
        if (rest < 1) return;

        const kasten = this.scroller.getBoundingClientRect();
        const pille = aktiv.getBoundingClientRect();
        if (pille.left >= kasten.left && pille.right <= kasten.right) return;

        /* Etwas Luft nach links, damit die Pill nicht an der Kante klebt
           und man sieht, dass davor noch etwas liegt. */
        const luft = 16;
        const ziel = this.scroller.scrollLeft + (pille.left - kasten.left) - luft;
        this.scroller.scrollLeft = Math.min(Math.max(ziel, 0), rest);

        /* Die Pfeile haengen am scrollLeft, sie muessen danach neu
           entscheiden, ob sie disabled sind. */
        this.update();
      }

      /* Eine Schiebe-Einheit ist eine gute Bildschirmbreite, aber nie mehr
         als der Rest. So springt es nie ins Leere. */
      slide(direction) {
        const step = Math.max(160, this.scroller.clientWidth * 0.8);
        this.scroller.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      update() {
        const rest = this.scroller.scrollWidth - this.scroller.clientWidth;

        /* Ein Pixel Toleranz, weil Browser bei Zoomstufen krumme Werte
           liefern und die Pfeile sonst flackern. */
        const laesstSichSchieben = rest > 1;
        this.arrows.hidden = !laesstSichSchieben;
        if (!laesstSichSchieben) return;

        const links = this.scroller.scrollLeft;
        this.buttons.forEach((button) => {
          const rueckwaerts = Number(button.dataset.dir) < 0;
          button.disabled = rueckwaerts ? links <= 1 : links >= rest - 1;
        });
      }
    }
  );
}

/*
  Live-Vorschlaege der Wissens-Suche.

  Das Bauteil heisst wissen-suchfeld und NICHT wissen-suche, weil
  .wissen-suche bereits die CSS-Klasse des Formulars ist. Gleicher Name fuer
  zwei Dinge liest sich in einer Woche wie ein Fehler.

  Umschliesst ein Suchformular des Bereichs und blendet waehrend des Tippens
  Beitrags-Treffer darunter ein. Es gibt zwei Formulare, eines in der
  Bereichszeile und eines in der Such-Schublade, beide bekommen ihr eigenes
  Bauteil. Sie sind nie gleichzeitig sichtbar.

  BEWUSST NICHT das Bauteil des Themes (assets/search.js, is="predictive-search").
  Dessen buildUrl kennt weder resources[type] noch die Feldangabe, und beide
  brauchen wir. Es zu erweitern hiesse, eine Datei anzufassen, die auch die
  Shop-Suche traegt. Die Abnahmebedingung des Auftrags lautet aber, dass die
  Shop-Suche unveraendert bleibt. Getrennte Bauteile machen das unmoeglich zu
  verletzen. Der Preis sind die rund sechzig Zeilen hier.

  Zwei Angaben an der Adresse sind der ganze Unterschied, beide am 24.08.2026
  am Live-Shop gemessen:

  1. resources[type]=article  sonst kommen Produkte.
  2. resources[options][fields]=title,body

     Die zweite ist die wichtigere und die unauffaelligere. OHNE sie durchsucht
     die Vorschlags-Suche NUR Titel. Die Ergebnis-Seite durchsucht dagegen von
     sich aus auch den Fliesstext. Testwort "Nierenerkrankungen", das in keinem
     Titel steht: Vorschlaege ohne Feldangabe null Treffer, Vorschlaege mit
     Feldangabe fuenf, Ergebnis-Seite zehn. Ohne die Zeile wuerde das Feld also
     "nichts gefunden" melden und nach dem Enter stuenden ploetzlich zehn
     Beitraege da.

     Das Feld "tag" wurde geprueft und weggelassen: Bei "Schlaf" liefert
     title,body zehn Treffer und title,body,tag ebenfalls zehn.

  Ohne dieses Skript bleibt das Formular ein normales Suchformular. Enter
  fuehrt weiterhin auf die Ergebnis-Seite. Die Vorschlaege sind Zugabe.
*/

if (!customElements.get('wissen-suchfeld')) {
  customElements.define(
    'wissen-suchfeld',
    class WissenSuchfeld extends HTMLElement {
      connectedCallback() {
        this.feld = this.querySelector('input[type="search"]');
        this.kasten = this.querySelector('[data-treffer]');
        if (!this.feld || !this.kasten) return;

        /* Ein Treffer-Abruf je Tastendruck waere Unfug. Erst wenn jemand
           kurz aufhoert zu tippen, wird gefragt. */
        this.warteZeit = 220;
        this.timer = null;
        this.zwischenspeicher = new Map();

        this.aufEingabe = this.aufEingabe.bind(this);
        this.aufTaste = this.aufTaste.bind(this);
        this.aufKlickAussen = this.aufKlickAussen.bind(this);

        this.feld.addEventListener('input', this.aufEingabe);
        this.addEventListener('keydown', this.aufTaste);
        document.addEventListener('click', this.aufKlickAussen);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abbrecher?.abort();
        document.removeEventListener('click', this.aufKlickAussen);
      }

      get suchwort() {
        return this.feld.value.trim();
      }

      aufEingabe() {
        clearTimeout(this.timer);

        /* Unter zwei Zeichen ist jeder Treffer Zufall. */
        if (this.suchwort.length < 2) {
          this.leeren();
          return;
        }

        this.timer = setTimeout(() => this.hole(), this.warteZeit);
      }

      aufTaste(ereignis) {
        if (ereignis.key === 'Escape') this.leeren();
      }

      aufKlickAussen(ereignis) {
        if (!this.contains(ereignis.target)) this.leeren();
      }

      leeren() {
        clearTimeout(this.timer);
        this.abbrecher?.abort();
        this.kasten.innerHTML = '';
        this.removeAttribute('data-offen');
        this.removeAttribute('data-laedt');
      }

      /*
        Die Adresse wird RELATIV zum aktuellen Ursprung gebaut, nicht ueber
        theme.routes.shop_url wie in assets/search.js. Zwei Gruende:

        1. shop_url ist die absolute myshopify-Adresse. Im lokalen
           shopify theme dev ist das ein fremder Ursprung, der Browser
           blockt den Abruf per CORS. Mit dem Theme-Suchfeld passiert
           dasselbe, es faellt dort nur niemandem auf, weil es live laeuft.
        2. Der Shop kann unter mehreren Domains erreichbar sein. Der Abruf
           soll auf der Domain bleiben, auf der der Besucher gerade ist.
           routes.predictive_search_url bringt eine noetige Sprach- oder
           Markt-Vorsilbe schon mit.
      */
      adresse() {
        const url = new URL(
          theme.routes.predictive_search_url,
          window.location.origin
        );
        url.searchParams.set('q', this.suchwort);
        url.searchParams.set('resources[type]', 'article');
        url.searchParams.set('resources[limit]', this.getAttribute('data-limit') || '6');
        url.searchParams.set('resources[options][fields]', 'title,body');
        url.searchParams.set('section_id', 'wissen-suche-vorschlaege');
        return url.toString();
      }

      hole() {
        const adresse = this.adresse();

        if (this.zwischenspeicher.has(adresse)) {
          this.zeige(this.zwischenspeicher.get(adresse));
          return;
        }

        this.abbrecher?.abort();
        this.abbrecher = new AbortController();
        this.setAttribute('data-laedt', '');

        fetch(adresse, { signal: this.abbrecher.signal })
          .then((antwort) => antwort.text())
          .then((text) => {
            this.zwischenspeicher.set(adresse, text);
            this.zeige(text);
          })
          .catch((fehler) => {
            if (fehler.name === 'AbortError') return;
            /* Faellt der Abruf aus, bleibt das Formular benutzbar. Kein
               Fehlertext im Weg, Enter fuehrt weiter zur Ergebnis-Seite. */
            this.leeren();
          });
      }

      /* Aus der Antwort wird nur der INHALT des Trefferkastens genommen,
         nicht der Kasten selbst. Sonst laege dessen ID zweimal in der Seite. */
      zeige(text) {
        const fremd = new DOMParser()
          .parseFromString(text, 'text/html')
          .getElementById('WissenSucheTreffer');

        this.removeAttribute('data-laedt');
        if (!fremd) {
          this.leeren();
          return;
        }

        this.kasten.innerHTML = fremd.innerHTML;
        this.toggleAttribute('data-offen', this.kasten.innerHTML.trim().length > 0);
      }
    }
  );
}
